import { useState } from "react";
import { Sparkles, Loader2, Copy, Check, FileText, MessageSquareReply, Wand2 } from "lucide-react";
import { apiFetch } from "@/portal/api";
import { toast } from "@/components/ui/sonner";

const MODES = [
  { key: "summarize", label: "Shrnout poznámky", icon: FileText, placeholder: "Vložte poznámky / text k shrnutí…" },
  { key: "reply", label: "Návrh odpovědi klientovi", icon: MessageSquareReply, placeholder: "Vložte poptávku / dotaz klienta…" },
  { key: "freeform", label: "Volný dotaz", icon: Wand2, placeholder: "Napište cokoliv (např. „Sepiš e-mail klientovi o prodloužení smlouvy“)…" },
];

const AiTab = ({ token }) => {
  const [mode, setMode] = useState("reply");
  const [text, setText] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const run = async () => {
    if (!text.trim()) { toast.error("Zadejte text."); return; }
    setLoading(true); setResult("");
    try {
      const r = await apiFetch("/admin/ai/assist", { method: "POST", token, body: { mode, text } });
      setResult(r.result || "");
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };
  const copy = () => { navigator.clipboard.writeText(result); setCopied(true); setTimeout(() => setCopied(false), 1500); };

  const active = MODES.find((m) => m.key === mode);

  return (
    <div className="max-w-3xl" data-testid="ai-tab">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles className="w-5 h-5 text-orange-400" />
        <h3 className="font-['Cabinet_Grotesk'] text-lg font-bold">AI asistent</h3>
      </div>
      <p className="text-xs text-zinc-500 mb-5">Pomocník na bázi Gemini – shrnutí poznámek, návrhy odpovědí klientům a texty. Výstup si před použitím vždy zkontrolujte.</p>

      <div className="flex flex-wrap gap-2 mb-4">
        {MODES.map((m) => (
          <button key={m.key} onClick={() => { setMode(m.key); setResult(""); }} className={`text-sm px-4 py-2 rounded-full border inline-flex items-center gap-2 ${mode === m.key ? "border-orange-500 bg-orange-500/15 text-orange-300" : "border-white/10 text-zinc-400 hover:text-white"}`} data-testid={`ai-mode-${m.key}`}>
            <m.icon className="w-4 h-4" /> {m.label}
          </button>
        ))}
      </div>

      <textarea className="input-dark w-full" rows={6} placeholder={active.placeholder} value={text} onChange={(e) => setText(e.target.value)} data-testid="ai-input" />
      <button onClick={run} disabled={loading} className="btn-accent mt-3 inline-flex items-center gap-2 disabled:opacity-60" data-testid="ai-generate">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Vygenerovat
      </button>

      {result && (
        <div className="glass rounded-2xl p-5 mt-5" data-testid="ai-result">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-zinc-500">Výsledek</span>
            <button onClick={copy} className="text-xs text-zinc-400 hover:text-white inline-flex items-center gap-1.5" data-testid="ai-copy">
              {copied ? <><Check className="w-3.5 h-3.5 text-emerald-400" /> Zkopírováno</> : <><Copy className="w-3.5 h-3.5" /> Kopírovat</>}
            </button>
          </div>
          <p className="text-sm text-zinc-200 whitespace-pre-wrap leading-relaxed">{result}</p>
        </div>
      )}
    </div>
  );
};

export default AiTab;
